import ReactGA from "react-ga";

export const initGA = () => {           
    ReactGA.initialize('G-XJYNQH0Q66'); 
 }

 export const PageView = () => {  
    ReactGA.pageview(window.location.pathname +  
                     window.location.search); 
}